import React from "react";
import styles from "./Separator.module.styl";
import cx from "classnames";
import PropTypes from "prop-types";

function Separator(props) {
    const { margin, color } = props;

    const marginClass = styles["margin_" + margin];
    const backgroundColorClass = styles["background_color_" + color];

    return <div className={cx(styles.separator, marginClass, backgroundColorClass)} />;
}

Separator.propTypes = {
    margin: PropTypes.oneOf(["big", "medium", "none"]),
    color: PropTypes.oneOf(["grey", "darkGrey"]),
};

Separator.defaultProps = {
    margin: "big",
    color: "grey",
};

export default Separator;
